import { render, staticRenderFns } from "./CyberboardXMAS.vue?vue&type=template&id=192921bc&scoped=true"
import script from "./CyberboardXMAS.vue?vue&type=script&lang=ts"
export * from "./CyberboardXMAS.vue?vue&type=script&lang=ts"
import style0 from "./CyberboardXMAS.vue?vue&type=style&index=0&id=192921bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192921bc",
  null
  
)

export default component.exports